/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/invasion': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<circle pid="0" cx="10" cy="2.5" r="1.5"/><circle pid="1" cx="10" cy="9.5" r="1.5"/><circle pid="2" cx="2" cy="9.5" r="1.5"/><circle pid="3" cx="7.5" cy="7" r="1.5"/><circle pid="4" cx="7.5" cy="12" r="1.5"/><circle pid="5" cx="12.5" cy="12" r="1.5"/><circle pid="6" cx="18" cy="9.5" r="1.5"/><circle pid="7" cx="12.5" cy="7" r="1.5"/><circle pid="8" cx="10" cy="17.5" r="1.5"/>'
  }
})
